export const environment = {
  production: true,
  apiUrl: 'https://www.ottimo-garage.ro/',
  appUrl: 'https://www.ottimo-garage.ro',
  googleCloudFileUrl: '',
  recaptchaKey: '',
  secretKey: 123,
  streamApiKey: '',
};
